module.exports = __webpack_public_path__ + "img/1-white.d51eeaaf.png";